/* eslint-disable @typescript-eslint/no-explicit-any */
import { createAction, props } from '@ngrx/store';
import { common, Hub } from '@qwyk/models';

export const loadPortalTeams = createAction(
    '[Hub/Administration/PortalTeams] Load PortalTeams',
    props<{ query: any }>()
);
export const loadPortalTeamsSuccess = createAction(
    '[Hub/Administration/PortalTeams] Load PortalTeams Success',
    props<{
        portalTeams: Hub.CustomerTeam[];
        pagination: common.PaginationMeta;
    }>()
);
export const loadPortalTeamsFailure = createAction(
    '[Hub/Administration/PortalTeams] Load PortalTeams Failure',
    props<{ error: any }>()
);

export const loadPortalTeam = createAction(
    '[Hub/Administration/PortalTeams] Load Portal Team',
    props<{ teamId: string }>()
);
export const loadPortalTeamSuccess = createAction(
    '[Hub/Administration/PortalTeams] Load PortalTeam Success',
    props<{ portalTeam: Hub.CustomerTeam }>()
);
export const loadPortalTeamFailure = createAction(
    '[Hub/Administration/PortalTeams] Load Portal Team Failure',
    props<{ error: any }>()
);

export const selectPortalTeam = createAction(
    '[Hub/Administration/PortalTeams] Select PortalTeam',
    props<{ id: string }>()
);

export const createPortalTeam = createAction(
    '[Hub/Administration/PortalTeams] Create PortalTeam',
    props<{ payload: any }>()
);
export const createPortalTeamSuccess = createAction(
    '[Hub/Administration/PortalTeams] Create PortalTeam Success',
    props<{ portalTeam: Hub.CustomerTeam }>()
);
export const createPortalTeamFailure = createAction(
    '[Hub/Administration/PortalTeams] Create PortalTeam Failure',
    props<{ error: any }>()
);

export const updatePortalTeam = createAction(
    '[Hub/Administration/PortalTeams] Update PortalTeam',
    props<{ id: string; payload: any }>()
);
export const updatePortalTeamSuccess = createAction(
    '[Hub/Administration/PortalTeams] Update PortalTeam Success',
    props<{ portalTeam: Hub.CustomerTeam }>()
);
export const updatePortalTeamFailure = createAction(
    '[Hub/Administration/PortalTeams] Update PortalTeam Failure',
    props<{ error: any }>()
);
